<div class="official-website-home-page">
  <div class="header-title">
    <h1><span>培训中心</span></h1>
    <!-- <p>Peace of mind for your valuable workshop equipment. Safely maintained on-site by Bosch Engineers. Enjoy the
      highest standard of after-sales service for your Bosch equipment with Bosch Equipment Services – from
      installation, calibration, maintenance and comprehensive extended warranties.</p> -->
  </div>
  <!-- <app-scroll-spy-nav [sections]="[
  { id: 'equipment', label: '培训中心' }]">
  </app-scroll-spy-nav> -->
  <section id="equipment" class="equipment-content">
    <div class="business-content">
      <div class="business-left">
        <img src="assets/official-website/training-center.png" alt="Spare Parts Image">
      </div>
      <div class="business-right">
        <h1><span style="display: block;">博世智能出行售后上海培训中心</span>
        </h1>
        <!-- <p>
          课程旨在培养专业维修技师找出问题的能力，以更有效的方式诊断和维修车辆，提高产能并减少车主的等待维修时间。
        </p>
        <p><strong>优势：</strong></p> -->
        <ul class="detail-list">
          <li>
            博世培训讲师团队均拥有多年教学及汽车技术及维修技术行业经验
          </li>
          <li>
            培训中心提供乘用车及商用车培训课程，涵盖面向未来的多等级新能源课程
          </li>
          <li>
            位于博世中国总部大楼
          </li>
          <li>
            教室场地面积130㎡，实操车间场地面积200㎡，配备最新的诊断设备及工具
          </li>
        </ul>
      </div>
    </div>
  </section>
</div>